import {
  distinctUntilChanged,
  map,
  switchMap,
  takeUntil,
} from "rxjs/operators";
import { EMPTY, of, Subject } from "rxjs";
import { get } from "lodash";
import { IgenomicsState } from "@ispm/core/interfaces/genomics-state.interface";
import { Injectable } from "@angular/core";
import { IWorkflowRequest } from "../interfaces/diagnostic-order.interface";
import { Observable } from "rxjs/Observable";
import { Store } from "@ngrx/store";
import { TestBarEnableConfirmButtonAction } from "../store/test-bar.actions";

@Injectable()
export class AllOrdersService {
  private destroyer$: Subject<void> = new Subject();

  constructor(private store$: Store<IgenomicsState>) {}

  /**
   * Validates disabling the action icons and confirm buttons for given workflow request for Biodesix workflow
   * @param currentWorkflow holds the workflow request data
   * @returns boolean value
   */
  validateActionDisableState(
    currentWorkflow: IWorkflowRequest
  ): Observable<boolean> {
    if (currentWorkflow.name === "Nodule Clinic") {
      const diagnostiOrdersAllOrder$ = this.store$.select(
        "tests",
        "diagnosticOrders",
        "allOrders"
      );

      return diagnostiOrdersAllOrder$.pipe(
        takeUntil(this.destroyer$.asObservable()),
        distinctUntilChanged(),
        map((orders) => {
          const disableActionIcons = orders.some(
            (order) =>
              get(order, "category", "") === "biodesix" &&
              (get(order, "derivedStatus.code", "") === "IN_PROCESS" ||
                get(order, "derivedStatus.code", "") === "ERROR")
          );
          return disableActionIcons;
        }),
        switchMap((disableActionIcons) => {
          if (
            disableActionIcons &&
            currentWorkflow.activeJobName === "documentsPreview"
          ) {
            this.store$.dispatch(new TestBarEnableConfirmButtonAction(false));
          } 
          return of(disableActionIcons);
        })
      );
    }
    return EMPTY;
  }
}
